/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface V1ImageVolumeSource
 */
export interface V1ImageVolumeSource {
    /**
     * PullPolicy describes a policy for if/when to pull a container image
     * +enum
     * @type {string}
     * @memberof V1ImageVolumeSource
     */
    pullPolicy?: string;
    /**
     * Required: Image or artifact reference to be used.
     * Behaves in the same way as pod.spec.containers[*].image.
     * Pull secrets will be assembled in the same way as for the container image by looking up node credentials, SA image pull secrets, and pod spec image pull secrets.
     * More info: https://kubernetes.io/docs/concepts/containers/images
     * This field is optional to allow higher level config management to default or override
     * container images in workload controllers like Deployments and StatefulSets.
     * +optional
     * @type {string}
     * @memberof V1ImageVolumeSource
     */
    reference?: string;
}

export function V1ImageVolumeSourceFromJSON(json: any): V1ImageVolumeSource {
    return V1ImageVolumeSourceFromJSONTyped(json, false);
}

export function V1ImageVolumeSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1ImageVolumeSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pullPolicy': !exists(json, 'pullPolicy') ? undefined : json['pullPolicy'],
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
    };
}

export function V1ImageVolumeSourceToJSON(value?: V1ImageVolumeSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pullPolicy': value.pullPolicy,
        'reference': value.reference,
    };
}

